/* ==========================================================================
   OTTR — the small behaviours on the buy page.

   Deliberately NOT here: adding to cart. That is Shopify's product form, and
   the moment this file starts intercepting a submit it takes back the thing it
   was written to hand over. If this script fails to load, the page still sells
   — the bar simply never appears and everything above the fold works.

   What is here:

   1 · The delivery estimate. No serviceability feed behind it; the bands are
       editable text and the answer says it is an estimate. The input is hidden
       in the markup and revealed from here, because a Check button that does
       nothing is worse than no Check button.

   2 · The sticky bar. It owns no state of its own — see the long note below.

   3 · Gift-field housekeeping. Blank properties are dropped by Shopify, so an
       untouched field costs nothing, but a note typed and then thought better
       of would still travel with the order. Closing the panel clears it.

   4 · The wishlist heart in the bar. Client-side only — see the note by it.

   Everything is delegated from the document and re-armed on Shopify's
   section:load, so the theme editor can re-render as often as it likes.
   ========================================================================== */

(function () {
  'use strict';

  var FORM = 'form[data-type="add-to-cart-form"]';

  /* ---- 1 · delivery ---------------------------------------------------- */

  /**
   * "500-509 | Hyderabad and around | 2-3 working days" -> a band.
   * A malformed line is skipped rather than throwing, because these are typed
   * into a textarea by a person and one stray pipe should not take the whole
   * widget down.
   */
  function parseBands(raw) {
    return (raw || '')
      .split('\n')
      .map(function (line) {
        var parts = line.split('|').map(function (s) { return s.trim(); });
        if (parts.length < 3) return null;
        var span = parts[0].split('-');
        var from = parseInt(span[0], 10);
        var to = parseInt(span[1] !== undefined ? span[1] : span[0], 10);
        if (isNaN(from) || isNaN(to)) return null;
        return { from: from, to: to, where: parts[1], when: parts[2] };
      })
      .filter(Boolean);
  }

  function answer(panel) {
    var input = panel.querySelector('[data-ottr-pin]');
    var out = panel.querySelector('.obx-deliver__out');
    if (!input || !out) return;

    var pin = (input.value || '').replace(/\D/g, '');

    if (pin.length !== 6) {
      out.setAttribute('data-state', 'bad');
      out.textContent = 'That needs to be six digits.';
      return;
    }

    var head = parseInt(pin.slice(0, 3), 10);
    var bands = parseBands(panel.getAttribute('data-bands'));
    var hit = null;

    for (var i = 0; i < bands.length; i++) {
      if (head >= bands[i].from && head <= bands[i].to) { hit = bands[i]; break; }
    }

    var fallback = panel.getAttribute('data-fallback') || '4–7 working days';
    out.removeAttribute('data-state');
    out.innerHTML = hit
      ? escapeHtml(hit.where) + ' — <b>' + escapeHtml(hit.when) + '</b>'
      : 'Delivered across India — <b>' + escapeHtml(fallback) + '</b>';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---- 2 · the sticky bar ---------------------------------------------- */

  /*
     THE BAR HAS NO QUANTITY OF ITS OWN, AND THAT IS THE WHOLE DESIGN.

     The version before this one carried its own name, strapline, price and
     button, and the button submitted the form — so the box could read 3 while
     the bar had been the thing that sent it, and the cart came back with a
     number neither control had shown. Two controls for one value is a bug
     waiting for a witness.

     So the bar is a remote. Its plus and minus write to the real quantity
     input inside Shopify's form and then read it back; its number is whatever
     that input currently says; its Add to cart is a submit button pointed at
     the same form by the `form` attribute. There is no second value anywhere
     to disagree with the first, and the bar cannot drift out of sync because
     it never holds anything.

     Min, max and step come off the real input, so Shopify's quantity rules
     apply to the bar without the bar knowing they exist.
  */

  function qtyInput() {
    var form = document.querySelector(FORM);
    return form ? form.querySelector('input[name="quantity"]') : null;
  }

  function readBack() {
    var input = qtyInput();
    var value = input ? (input.value || '1') : '1';
    document.querySelectorAll('[data-ottr-bar-qty]').forEach(function (node) {
      node.textContent = value;
    });
  }

  function step(by) {
    var input = qtyInput();
    if (!input) return;

    var min = parseInt(input.getAttribute('min') || input.getAttribute('data-min') || '1', 10);
    if (isNaN(min)) min = 1;
    var by_step = parseInt(input.getAttribute('step') || '1', 10);
    if (isNaN(by_step) || by_step < 1) by_step = 1;
    var maxAttr = input.getAttribute('max');
    var max = maxAttr ? parseInt(maxAttr, 10) : null;

    var now = parseInt(input.value, 10);
    if (isNaN(now)) now = min;

    var next = now + by * by_step;
    if (next < min) next = min;
    if (max !== null && !isNaN(max) && next > max) next = max;

    input.value = String(next);
    /* Both events, because the theme's quantity selector listens for one and
       anything watching the form listens for the other. */
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    readBack();
  }

  function drawerIsOpen() {
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    return !!(drawer && drawer.hasAttribute('open'));
  }

  var barGone = false;

  function paintBar() {
    var bar = document.querySelector('[data-ottr-bar]');
    if (!bar) return;
    if (barGone && !drawerIsOpen()) {
      bar.setAttribute('data-show', '');
    } else {
      bar.removeAttribute('data-show');
    }
  }

  /**
   * The bar appears when the real buy row has left the top of the window, and
   * only then — not on a scroll threshold, not after N pixels. It is the same
   * pair of controls, so showing it while the originals are still on screen
   * would put two of everything in front of the reader.
   */
  function watchBuyRow() {
    var anchor = document.querySelector('.obx-buy');
    var bar = document.querySelector('[data-ottr-bar]');
    if (!anchor || !bar || bar.dataset.ottrArmed) return;

    bar.dataset.ottrArmed = '1';
    bar.removeAttribute('hidden');
    readBack();

    if (!('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      barGone = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      paintBar();
    }, { threshold: 0 }).observe(anchor);

    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(paintBar).observe(drawer, {
        attributes: true,
        attributeFilter: ['open']
      });
    }
  }

  /* ---- 3 · the wishlist heart -------------------------------------------
     Client-side only — there is no wishlist app installed, so this is a
     localStorage list of product handles, per browser. It does not sync to
     an account or another device; it exists so the control is real rather
     than decorative, not as a promise of a synced wishlist feature. */

  var WISH_KEY = 'ottr:wishlist';

  function readWishlist() {
    try {
      var raw = window.localStorage.getItem(WISH_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(list) {
    try { window.localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function paintWish(btn) {
    var handle = btn.getAttribute('data-handle');
    var on = !!handle && readWishlist().indexOf(handle) > -1;
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function toggleWish(btn) {
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var list = readWishlist();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    writeWishlist(list);
    paintWish(btn);
  }

  /* ---- 3 · the gallery carousel ------------------------------------------
     Swipe is native scroll-snap; this only drives the arrows and the dots
     to match. Nothing here touches touch events — the browser already
     handles that better than a hand-written handler would. */

  function wireGallery(root) {
    (root || document).querySelectorAll('[data-ottr-gal]').forEach(function (gal) {
      if (gal.dataset.ottrWired) return;
      gal.dataset.ottrWired = '1';

      var track = gal.querySelector('[data-ottr-gal-track]');
      var slides = track ? Array.prototype.slice.call(track.children) : [];
      var prev = gal.querySelector('[data-ottr-gal-prev]');
      var next = gal.querySelector('[data-ottr-gal-next]');
      var dotsWrap = gal.querySelector('[data-ottr-gal-dots]');

      if (slides.length < 2) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        return;
      }

      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        slides.forEach(function (_, i) {
          var dot = document.createElement('i');
          if (i === 0) dot.className = 'on';
          dotsWrap.appendChild(dot);
        });
      }

      function paint() {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        if (prev) prev.hidden = idx <= 0;
        if (next) next.hidden = idx >= slides.length - 1;
        if (dotsWrap) {
          Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
            dot.classList.toggle('on', i === idx);
          });
        }
      }

      function go(dir) {
        track.scrollBy({ left: track.clientWidth * dir, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      var queued = false;
      track.addEventListener('scroll', function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; paint(); });
      }, { passive: true });

      window.addEventListener('resize', paint);
      paint();
    });
  }

  /* ---- 4 · arming ------------------------------------------------------ */

  function arm(root) {
    (root || document).querySelectorAll('[data-ottr-deliver][hidden]').forEach(function (panel) {
      panel.removeAttribute('hidden');
    });
    watchBuyRow();
    readBack();
    (root || document).querySelectorAll('[data-ottr-wish]').forEach(paintWish);
    wireGallery(root);
  }

  /* ---- 4 · one listener each, on the document -------------------------- */

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var go = event.target.closest('[data-ottr-pin-go]');
    if (go) {
      var panel = go.closest('[data-ottr-deliver]');
      if (panel) answer(panel);
      return;
    }

    var stepper = event.target.closest('[data-ottr-bar-step]');
    if (stepper) {
      step(parseInt(stepper.getAttribute('data-ottr-bar-step'), 10) || 0);
      return;
    }

    var wish = event.target.closest('[data-ottr-wish]');
    if (wish) {
      event.preventDefault();
      toggleWish(wish);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest && event.target.closest('[data-ottr-pin]');
    if (!input) return;
    event.preventDefault();
    var panel = input.closest('[data-ottr-deliver]');
    if (panel) answer(panel);
  });

  document.addEventListener('input', function (event) {
    if (!event.target.closest) return;

    var pin = event.target.closest('[data-ottr-pin]');
    if (pin) {
      var panel = pin.closest('[data-ottr-deliver]');
      var out = panel && panel.querySelector('.obx-deliver__out');
      if (out) { out.textContent = ''; out.removeAttribute('data-state'); }
      return;
    }

    /* The box's own stepper, or someone typing into it. The bar follows. */
    if (event.target.matches('input[name="quantity"]')) readBack();
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('input[name="quantity"]')) readBack();
  });

  document.addEventListener('toggle', function (event) {
    var gift = event.target;
    if (!gift.matches || !gift.matches('[data-ottr-gift]')) return;
    if (gift.open) return;
    gift.querySelectorAll('textarea, input[type="text"]').forEach(function (field) {
      field.value = '';
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arm(document); });
  } else {
    arm(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var bar = document.querySelector('[data-ottr-bar]');
    if (bar) delete bar.dataset.ottrArmed;
    arm(event.target);
  });
})();
